import * as React from 'react'

import { ListSelector } from '~/client/src/shared/components/ListSelector'
import Localization from '~/client/src/shared/localization/LocalizationManager'

interface IProps {
  title: string
  onClose: () => void
}

export const MapViewsSidebarHeader: React.FC<IProps> = ({ title, onClose }) => (
  <ListSelector.Title
    title={title}
    onClose={onClose}
    closeLabel={Localization.translator.closeMapViews}
  />
)
